<template>
  <vz-article-item v-if="article" :article="article"/>
</template>

<script setup lang="ts">
import {ref} from "vue";
import {getNewsArticle} from "~/api/home";
import VzArticleItem from "~/components/public/news/vz-article-item.vue";
import {EventRecord} from "~/types/components/personal/actions";

definePageMeta({
  path: '/:tag(news|actions)/:id'
})

async function getArticle() {
  const response = await getNewsArticle({href: useRoute().params.id as string, preview: false})
  if (!response?.length) {
    showError({ statusCode: 404, statusMessage: "Page Not Found" })
    return
  }
  return response[0]
}

const article = ref(await getArticle())
</script>
